module.exports = {"610602001":"宝塔山街道","610602002":"南市街道","610602003":"凤凰山街道","610602004":"枣园街道","610602005":"桥沟街道","610602006":"新城街道","610602102":"河庄坪镇","610602103":"李渠镇","610602104":"姚店镇","610602105":"青化砭镇","610602106":"蟠龙镇","610602107":"柳林镇","610602108":"南泥湾镇","610602109":"临镇","610602110":"甘谷驿镇","610602111":"万花山镇","610602112":"川口镇","610602113":"麻洞川镇","610602202":"冯庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610602.json
// module id = 2970
// module chunks = 0